// not all component's data types are defined in '@wix/editorx-core-api', so we need to use '@wix/document-services-types' to import them

import { ComponentType } from '../../common';
export const isRichTextData = data => (data == null ? void 0 : data.type) === 'StyledText' || (data == null ? void 0 : data.type) === 'RichText';
export const isWPhotoData = data => (data == null ? void 0 : data.type) === 'Image';
export const isImageXData = data => (data == null ? void 0 : data.type) === 'ImageX';
export const isVectorImageData = data => (data == null ? void 0 : data.type) === 'VectorImage';
export const isTpaWidgetData = data => data && data.type === 'TPAWidget';
export const isVideoPlayer = data => (data == null ? void 0 : data.type) === 'VideoPlayer';
export const isAudioPlayer = data => (data == null ? void 0 : data.type) === 'MusicPlayerData';
export const isMediaPlayer = design => (design == null ? void 0 : design.type) === 'MediaPlayerDesignData';
export const isBackgroundMedia = design => {
  var _design$background;
  return (design == null || (_design$background = design.background) == null ? void 0 : _design$background.type) === 'BackgroundMedia';
};

// Temporary type guard for builder image data until the core-api is updated
export const isBuilderImageContainer = data => !!data && typeof data === 'object' && Object.values(data).some(v => isBuilderImageData(v));
export const isBuilderImageData = data => !!data && typeof data === 'object' && (data == null ? void 0 : data.type) === ComponentType.BuilderImage;
export const isBuilderVectorArtContainer = data => !!data && typeof data === 'object' && Object.values(data).some(v => isBuilderVectorArtData(v));
export const isBuilderVectorArtData = data => !!data && typeof data === 'object' && (data == null ? void 0 : data.type) === ComponentType.BuilderVectorArt;
export const isBackgroundVideo = bg => {
  const mediaRef = bg.mediaRef;
  return mediaRef !== undefined && mediaRef.type === 'WixVideo';
};
export const isWixVideo = data => (data == null ? void 0 : data.type) === 'WixVideo';
export const isFastGalleryData = data => (data == null ? void 0 : data.type) === 'wixGalleriesElements.FastGallery';
export const isBuilderRichTextContainer = data => {
  var _data$richText;
  return (data == null || (_data$richText = data.richText) == null ? void 0 : _data$richText.type) === 'Builder.RichText';
};
//# sourceMappingURL=components-type-guards.js.map